import SubHeader from "../../components/elements/SubHeader";
import Sidebar from "../../components/plan-content-presets-compile/Sidebar";
import { CollapseContainerContextProvider } from "../../context/collapse-container.context";
import SubNav from "../../components/plan-template/SubNav";
import EditorContent from "../../components/plan-template/EditorContent";
import { useEffect, useState } from "react";
import LayoutSidebar from "../../components/layout/LayoutSidebar";
import { useLoaderData, useSearchParams } from "react-router-dom";
import GoalsContent from "../../components/plan-content-presets-compile/GoalsContent";
import IconContainer from "../../components/utils/IconContainer";
import ConfirmModal from "../../components/popups/ConfirmPopup";
import PlanOriginalTextPopup from "../../components/popups/PlanOriginalTextPopup";
import ActionBtnItem from "../../components/utils/ActionBtnItem";
import PopoverActionStatus from "../../components/plan-template/PopoverActionStatus";
import { getTemplatePlanContent } from "../../services/plans-template.service";
import TextareaInput from "../../components/input/TextareaInput";
import debounce from "lodash.debounce";
import useDateFormatter from "../../hooks/date-formatter.hook";
import { usePlanContentPresetsCompileStore } from "../../store/plan-content-presets-compile.store";
import { ARRAY_STATUS_ICON } from "../../helper/common.helper";
import { getSfadCourses } from "../../services/course.service";
import { editTemplatesPlansContentPresetEditorContent } from "../../services/plans-template-content-preset-editor.service";
import OverlayPage from "../../components/plan-content-presets-compile/OverlayPage";

function PlanContentPresetsCompile({ role = "admin" }) {
	const {
		loaderData: {
			plan: { plan: planData, editor_context, content_preset },
		},
	} = useLoaderData();

	const [searchParams] = useSearchParams();

	const {
		selectedContent,
		chapterList,
		isSavingContent,
		updateState,
		editContent,
		updateContentStatus,
		deleteConf,
		selectContentHandler,
		reset,
	} = usePlanContentPresetsCompileStore();

	const { formatDate, formatDateToTimestamp } = useDateFormatter();

	const [openResetContent, setOpenResetContent] = useState(false);

	const [resetCounter, setResetCounter] = useState(0);

	const [planOriginalTextPopupOpen, setPlanOriginalTextPopupOpen] = useState(false);

	useEffect(() => {
		reset();

		updateState({
			chapterList: planData.organization_contents,
			planDetail: planData,
			roleSettings: role,
			editorContext: editor_context,
			changesList: [],
		});

		// Init content by searchParams
		const searchChapter = Number(searchParams.get("chapter"));
		const searchGoal = Number(searchParams.get("goal"));
		const searchContent = Number(searchParams.get("content"));
		let item = null;

		if (!Number.isNaN(searchChapter)) {
			const chapterContent = planData.organization_contents.find(
				(item) => item.content_id === searchChapter
			);
			if (chapterContent) {
				if (!Number.isNaN(searchGoal) && searchGoal > 0) {
					item = chapterContent.data.organization_contents.find(
						(item) => item.content_id === searchGoal && item.content_type === "organization_goal"
					);
				} else if (!Number.isNaN(searchContent) && searchContent > 0) {
					item = chapterContent.data.organization_contents.find(
						(item) =>
							item.content_id === searchContent &&
							item.content_type === "organization_chapter_content"
					);
				}
			}

			if (item) {
				selectContentHandler(item);
			}
		}
	}, []);

	useEffect(() => {
		getSfadCourses(undefined, (res) => {
			updateState({ courses: res?.data ?? [] });
		});
	}, []);

	const arrayStatusContent = [
		{
			title: "Da gestire",
			icon: "uncompleted",
			value: "uncompleted",
			color: ARRAY_STATUS_ICON?.find((s) => s.icon === "uncompleted")?.color ?? "",
		},
		{
			title: "Completato",
			icon: "completed",
			value: "completed",
			color: ARRAY_STATUS_ICON?.find((s) => s.icon === "completed")?.color ?? "",
		},
	];

	/**
	 * Template Nav
	 * @returns
	 */
	const templateNav = () => (
		<div className="main_comp_actions_group">
			<div className="main_list_status_container">
				{isSavingContent.length > 0 && (
					<IconContainer icon="loader opacity-70" tooltip="Salvataggio in corso" />
				)}

				{selectedContent.content_type === "organization_goal" &&
					selectedContent?.data?.template_goal?.status !== "default" && (
						<>
							<IconContainer
								icon={
									"icon_mask !bg-interactive-100 " +
									(selectedContent?.data?.template_goal?.status === "new" ? "megaphone" : "update")
								}
								tooltip={
									selectedContent?.data?.template_goal?.status === "new" ? "Nuovo" : "Modificato"
								}
							/>

							{selectedContent?.data?.organization_requirements.find(
								(el) => el.status === "uncompleted"
							) && <IconContainer icon="danger_corp" tooltip="Da gestire" />}
						</>
					)}

				{selectedContent?.content_type === "organization_chapter_content" &&
					selectedContent?.data?.status !== null && (
						<>
							<ActionBtnItem
								icon="preview"
								big
								onClick={() => setPlanOriginalTextPopupOpen(true)}
								tooltip="Anteprima documento di ripristino"
							/>

							{formatDateToTimestamp(selectedContent?.data?.template_chapter_content?.updated_at) >
								formatDateToTimestamp(selectedContent?.data?.updated_at) && (
								<ActionBtnItem
									icon="danger"
									layout={"my-[4px] !bg-white"}
									iconLayout={""}
									small
									tooltip={`Template modificato il ${formatDate(
										selectedContent?.data?.template_chapter_content?.updated_at,
										"DD MMM YYYY, HH:mm"
									)}`}
								/>
							)}

							<PopoverActionStatus
								layout="small"
								onChange={(value) => updateContentStatus(value)}
								initStatus={selectedContent?.data?.status}
								arrayStatus={arrayStatusContent}
							/>

							{role === "admin" && (
								<button
									className=" link-red  text-12 ml-3"
									onClick={() => setOpenResetContent(true)}
									type="button"
								>
									Ripristina documento
								</button>
							)}
						</>
					)}
			</div>
		</div>
	);

	/**
	 * Reset Content Document
	 */
	const resetContentDocument = () => {
		getTemplatePlanContent({ id: selectedContent.data.template_chapter_content_id }, (res) => {
			editTemplatesPlansContentPresetEditorContent(
				{
					templatePlan: planData.template_plan_id,
					contentPreset: planData.content_preset_id,
					templateChapterContent: selectedContent.content_id,
					editorjs: res.data.editorjs,
					status: "uncompleted",
				},
				(res) => {
					const findChapt = chapterList.find(
						(c) => c.content_id === selectedContent.data.organization_chapter_id
					);

					const findContent = findChapt.data.organization_contents.find(
						(c) =>
							c.content_id === selectedContent.content_id &&
							c.content_type === selectedContent.content_type
					);

					findContent.data.status = "uncompleted";

					updateState({
						selectedContent: {
							...selectedContent,
							data: {
								...res.data,
							},
						},
						chapterList: [...chapterList],
					});

					setResetCounter((r) => r + 1);
					setOpenResetContent(false);
					setPlanOriginalTextPopupOpen(false);
				}
			);
		});
	};

	return (
		<LayoutSidebar>
			<div onClick={(e) => e.stopPropagation()} onKeyUp={(e) => e.stopPropagation()}>
				<SubHeader
					back
					backHref={`/admin/plans/template/detail/${planData.template_plan.id}`}
					title={planData.template_plan.name}
					titleSmall
					description={planData.template_plan.description}
				/>

				<CollapseContainerContextProvider>
					<Sidebar planData={planData} />
				</CollapseContainerContextProvider>

				<div className="main_page_sidebar">
					{selectedContent && (
						<>
							<SubNav
								category={
									selectedContent.content_type === "organization_chapter_content" && `Documento`
								}
								title={
									selectedContent.content_type === "organization_goal"
										? `${selectedContent.data.template_goal.name} – ${selectedContent.data.template_goal.description}`
										: selectedContent.data.template_chapter_content.name
								}
								TemplateRightContent={templateNav}
							/>

							<div className="wrap_page_sidebar">
								{selectedContent.content_type === "organization_chapter_content" ? (
									<div
										key={selectedContent.content_id + resetCounter}
										className={`bg-white rounded-[4px]`}
									>
										{selectedContent.data.status !== null && (
											<div className={`p-[28px_28px_0_86px] max-w-[1200px] mx-auto`}>
												<div className={`font-semibold text-[12px] text-dark-50 mb-[8px]`}>
													Note amministrative
												</div>
												<TextareaInput
													model={selectedContent.data.admin_note}
													onChange={debounce(
														(data) =>
															editContent(
																"adminNote",
																data.target.value,
																selectedContent.content_id
															),
														400
													)}
													className={""}
												/>
											</div>
										)}

										<EditorContent
											initVal={selectedContent.data.editorjs}
											onChange={debounce(
												(data) => editContent("editorjs", data, selectedContent.content_id),
												400
											)}
											headerLevels={[2]}
											readOnly={selectedContent.data.status == null}
										/>
									</div>
								) : (
									<GoalsContent />
								)}
							</div>
						</>
					)}
				</div>
			</div>

			{/* Reset content */}
			<ConfirmModal
				open={openResetContent}
				setOpen={setOpenResetContent}
				title="Ripristina documento"
				alertMessage="Attenzione! Ripristinando il documento perderai tutte le modifiche fatte. <b>Sei sicuro di procedere?</b>"
				ctaLabel="Conferma"
				onConfirm={resetContentDocument}
			/>

			{/* Plan original popup */}
			<PlanOriginalTextPopup
				open={planOriginalTextPopupOpen}
				selectedContent={selectedContent?.data}
				setOpen={setPlanOriginalTextPopupOpen}
				setReset={setOpenResetContent}
			/>

			{/* Confirm content */}
			<ConfirmModal
				open={deleteConf.isOpen}
				setOpen={(isOpen) => updateState({ deleteConf: { ...deleteConf, isOpen } })}
				title={deleteConf.title}
				icon={deleteConf.icon}
				subtitle={deleteConf.subtitle}
				description={deleteConf.description}
				alertMessage="Attenzione! Questa operazione è irreversibile! <b>Sei sicuro di procedere?</b>"
				ctaLabel="Elimina"
				onConfirm={() => deleteConf.confirmHandler(deleteConf.item)}
			/>

			<OverlayPage title={content_preset.title} />
		</LayoutSidebar>
	);
}

export default PlanContentPresetsCompile;
